<template>
  <div class="friction-circle-chart">
    <div style="position: relative; margin: 22px">
      <!-- 垂向力 -->
      <div
        class="absolute text-inside"
        :class="{
          left: props.name.includes('右'),
          right: props.name.includes('左'),
        }"
      >
        <Statistic
          name="垂向力"
          :value="((values.vertDynF || 0) / 1000).toFixed(1)"
          units-of-measurement="kN"
          icon=""
          :width="120"
          style="font-size: 14px"
          :color="'false'"
        ></Statistic>
        <!-- {{ ((values.vertDynF || 0) / 1000).toFixed(1) }} kN -->
      </div>
      <!-- 估计附着 -->
      <div
        class="absolute text-outside"
        :style="{
          left: props.name.includes('左') ? '-30px' : 'unset',
          right: props.name.includes('右') ? '-30px' : 'unset',
        }"
      >
        <Statistic
          name="附着"
          :value="(values.mue || 0).toFixed(1)"
          units-of-measurement=" "
          icon=""
          :width="50"
          style="font-size: 14px"
          :color="'false'"
        ></Statistic>
        <!-- {{ values.mue }} -->
      </div>
      <!-- border: 1px solid rgb(73 98 107);    box-shadow: rgb(129 150 158 / 80%) 0px 0px 19px 4px;  -->
      <div
        class="chart-warp relative-position"
        :style="{
          height: chartWidth + 'px',
          width: chartHeight + 'px',
        }"
      >
        <div
          class="absolute fit"
          style="z-index: 99; border-radius: 50%; overflow: hidden"
        >
          <Charts :options="optionsACC" ref="chartsACC" />
        </div>

        <div
          class="absolute fit background"
          style="
            top: 0;
            left: 0;
            z-index: 1;
            border-radius: 50%;
            overflow: hidden;
          "
          :class="{ animation: values.vertDynF > 9000 }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import Charts from "@/components/Charts";
import { getChartDefaulOpiotns3 } from "./helper";
import { getDefaultSeriesData } from "../../helper/icc";
import { debounce } from "lodash-es";
import { chartHeight, chartWidth } from "./helper";
import Statistic from "../IVSE/Statistic";

const emit = defineEmits(["reset"]);

type Values = {
  radius: number;
  angle: number;
  vertDynF: number;
  mue: number;
};

interface Props {
  notifyData: DomianControl.IVSENotifyData;
  name: "左前" | "右前" | "右后" | "左后";
  type?: "leftFront" | "rightFront" | "rightBack" | "leftBack";
}
const props = withDefaults(defineProps<Props>(), {
  notifyData: () => ({} as DomianControl.IVSENotifyData),
  name: "左前",
});

const optionsACC = ref(getChartDefaulOpiotns3());
const chartsACC = ref();

const values = computed(() => {
  const { name, notifyData } = props;
  let radius = 0;
  let angle = 0;
  let vertDynF = 0; // 垂向力
  let mue = 0; // 估计附着
  if (name === "左前") {
    angle = notifyData.UIRx_ThetaFxyFA;
    radius = notifyData.UIRx_FxyFL;
    vertDynF = notifyData.UIRx_FLVertDynF;
    mue = notifyData.UIRx_mueFL;
  }
  if (name === "右前") {
    angle = notifyData.UIRx_ThetaFxyFA;
    radius = notifyData.UIRx_FxyFR;
    vertDynF = notifyData.UIRx_FRVertDynF;
    mue = notifyData.UIRx_mueFR;
  }

  if (name === "左后") {
    angle = notifyData.UIRx_ThetaFxyRA;
    radius = notifyData.UIRx_FxyRL;
    vertDynF = notifyData.UIRx_RLVertDynF;
    mue = notifyData.UIRx_mueRL;
  }
  if (name === "右后") {
    angle = notifyData.UIRx_ThetaFxyRA;
    radius = notifyData.UIRx_FxyRR;
    vertDynF = notifyData.UIRx_RRVertDynF;
    mue = notifyData.UIRx_mueRR;
  }

  return {
    radius,
    angle,
    vertDynF,
    mue,
  } as Values;
});

const reset = debounce(() => {
  emit("reset");
}, 500);

watch(
  () => values,
  (newValue) => {
    optionsACC.value = getChartDefaulOpiotns3(
      newValue.value.radius,
      newValue.value.angle,
      newValue.value.vertDynF
    );
  },
  { deep: true }
);
</script>
<style scoped>
.chart-warp {
  border-radius: 50%;
  box-sizing: border-box;
  border: 4px solid #ffffff;
}
.background {
  border-radius: 50%;
}

.text-inside,
.text-outside {
  bottom: 0;
  font-size: 20px;
  font-weight: 900;
}

.left {
  left: -85px;
}
.right {
  right: -75px;
}

.animation {
  box-shadow: rgb(129 150 158 / 80%) 0px 0px 60px 20px;
  animation: shadowExpand 1s ease-in-out infinite;
}
@keyframes shadowExpand {
  0% {
    border-radius: 50%;
    transform: translateZ(0);
    transform: scale(0.8);
    /* box-shadow: rgb(129 150 158 / 80%) 0px 0px 0px 0px; */
  }
  50% {
    border-radius: 50%;
    transform: translateZ(0);
    transform: scale(1);
    /* box-shadow: rgb(129 150 158 / 80%) 0px 0px 40px 8px; */
  }
  100% {
    border-radius: 50%;
    transform: translateZ(0);
    transform: scale(0.8);
    /* box-shadow: rgb(129 150 158 / 80%) 0px 0px 0px 0px; */
  }
}
</style>
